import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import { hasSubscriptionPermission, hasAccess, hasPartnerSubscriptionPermission } from '../../../../../utils/auth'
import { translation } from '../../../../../utils/helpers'
// Styles
import { RenderTypes } from '../../../../../constants'
import { GetConfig } from '../configuration.js'
import InputCheckbox from '../InputComponents/InputCheckbox'
import InputField from '../InputComponents/InputField'
import InputSelectList from '../InputComponents/InputSelectList'
import RadioList from '../InputComponents/RadioList'
// import OrderDate from '../OrderDate'

import Text from '../../../../../shared/elements/text'
import Textarea from '../../../../../shared/elements/textarea'
import DropDown from '../../../../../shared/elements/dropDown'

class InputRender extends PureComponent {

  constructor (props) {
    super(props)
    this.onInputChange = this.onInputChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }
  onInputChange (e) {
    this.context.onChange(e)
  }
  onBlur (e) {
    let onBlur = typeof this.props.onBlur === 'function' ? this.props.onBlur : this.context.onBlur
    onBlur(e)
  }
  formatFormatter (displayValue, formatter) {
    if (typeof this.props.formatter === 'function') displayValue = formatter(displayValue)
    return displayValue
  }

  shouldComponentUpdate (nextProps) {
    const forceUpdate = nextProps.propName === 'IsBodyShopOrder' || nextProps.propName === 'IsPaintOrder' || nextProps.propName === 'HasRequestedCarRental'  // (nextProps.translateName === '14830')
    return !isEqual(this.props.order[this.props.propName], nextProps.order[this.props.propName]) || !isEqual(this.props.listItems, nextProps.listItems) || forceUpdate
  }
  dimensionShow (dimensions) {
    let show = false
    dimensions.map((val, key) => {
      if (!show) {
        let higherThan = val[0]
        let lessThan = val[1]
        let width = this.context.dimensions.width
        if (width > higherThan && width <= lessThan) show = true
      }
    })
    return show
  }
  renderDisplayFormatter (renderType, displayValue) {
    if (renderType !== RenderTypes.FORMATTER) return null
    let isCustomer = hasAccess([4], this.props.auth.user.UserType)
    let isDraft = this.props.auth.user.DepartmentType === 0 && this.props.order.IsDraft || this.props.auth.user.DepartmentType === 1 && this.props.order.BodyShopIsDraft
    if (isCustomer && !isDraft) {
      if (displayValue !== null && displayValue.Id !== undefined) {
        displayValue = displayValue.Name
        if (this.props.propName === 'BrandName') displayValue = translation(displayValue)
      }
      if (['BodyShopLoosePartsType', 'LoosePartsType'].includes(this.props.propName) && displayValue !== null) {
        displayValue = displayValue ? translation('75') : translation('76')
      }
      if (['PickupAltLocationId', 'DeliveryAltLocationId', 'BodyShopPickupAltLocationId', 'BodyShopDeliveryAltLocationId'].includes(this.props.propName)) {
        let items = this.props.listItems.filter(x => x.CustomerClientId === displayValue)
        if (Array.isArray(items) && items.length > 0) displayValue = items[0].DisplayVal
      }
    }
    return (
      <Text
        value={this.formatFormatter(displayValue, this.props.formatter)}
        disabled
        labelText={translation(this.props.translateName)}
      />
    )
    // return <div><label>{translation(this.props.translateName)}</label>{this.formatFormatter(displayValue, this.props.formatter)}</div>
  }
  getIcon (src, title) {
    return <span className='GoRight'><img src={src} title={translation(title)} style={{ width: 20, height: 20 }} /></span>
  }
  renderInputfield (renderType, displayValue) {
    if (![RenderTypes.INPUT, RenderTypes.INPUTICON].includes(renderType)) return null
    let colorIcon = null
    let disabledInput = (this.props.propName === 'LTWIdCode' && !hasSubscriptionPermission(this.props.auth, 0, 2)) || this.context.disabledForWP || (this.props.propName === 'ColorAmount' && this.props.order.IsReferredOut)
    if (renderType === RenderTypes.INPUTICON) {
      if (this.props.propName === 'Color') colorIcon = this.getIcon('/images/svgs/color/Color.svg', '179')
      if (this.props.propName === 'ColorCode') colorIcon = this.getIcon('/images/svgs/color/Color_code.svg', '79')
      if (this.props.propName === 'ColorVariant') colorIcon = this.getIcon('/images/svgs/color/color-variation.svg', '13388')
      if (this.props.propName === 'ColorAmount') colorIcon = this.getIcon('/images/svgs/color/Color_amount-VS.svg', '13392')
    }
    return <InputField title={this.props.translateName} icon={colorIcon} name={this.props.propName} value={this.props.order[this.props.propName] !== null ? (this.props.propName === 'ChassisNumber' ? this.props.order[this.props.propName].toUpperCase() : this.props.order[this.props.propName]) : ''} disabled={disabledInput} onChange={this.onInputChange} onBlur={this.onBlur} />
  }
  renderCheckbox (renderType, displayValue) {
    const { order, propName } = this.props
    if (![RenderTypes.CHECKBOXICON, RenderTypes.CHECKBOX].includes(renderType)) return null
    if (renderType === RenderTypes.CHECKBOXICON) {
      let colorIcon = this.getIcon('/images/svgs/color/Color-ok.svg', '13393')
      return <InputCheckbox title={this.props.translateName} name={propName} icon={colorIcon} disabled={(propName === 'ColorControlIncluded' || propName === 'LTW' || propName === 'SuppressSMS') && !hasSubscriptionPermission(this.props.auth, 0, 2) || this.context.disabledForWP} onChange={this.onInputChange} checked={order[propName] === true ? 'checked' : false} />
    }
    let disableCheckbox = false
    let checked = false
    if (order[propName] === true) checked = true
    if ((order.DisabledBodyShopChange || !order.BodyShopIsDraft || !order.PaintIsDraft) && propName === 'IsBodyShopOrder') {
      if (this.props.auth.departmentType === 2) {
        disableCheckbox = !order.IsDraft
      } else {
        disableCheckbox = true
      }
    }
    if (propName === 'HasSpareParts' && (order.IsReferredOut || !hasSubscriptionPermission(this.props.auth, 30, 31))) disableCheckbox = true
    if (propName === 'HasRequestedCarRental' && (order.HasCarRental /* || hasAccess([4], this.props.auth.user.UserType) */ || !order.CurrentShopCanAssignRentalCar)) disableCheckbox = true
    if ((order.DisabledPaintChange || !order.IsDraft) && this.props.propName === 'IsPaintOrder' || this.context.disabledForWP) disableCheckbox = true
    if (propName === 'ColorIsReady' && order.IsReferredOut) disableCheckbox = true
    if (propName === 'ColorControlIncluded' && order.IsReferredOut && this.props.auth.user.DepartmentType === 1) disableCheckbox = true
    if (['HasBodyShopPickupAltLocation', 'HasBodyShopDeliveryAltLocation'].includes(propName) && order.IsReferredIn) disableCheckbox = true
    if (this.props.auth.user.DepartmentType === 1 && ['HasPickupAltLocation', 'HasDeliveryAltLocation'].includes(propName) && order.IsReferredOut) disableCheckbox = true

    const onDisabledClick = () => {
      if (order.IsDraft) {
        window.toastr.error(translation('15043'), translation('216'))
      } else {
        window.toastr.error(translation('14865'), translation('216'))
      }
    }

    const bodyShopClassName = propName === 'IsBodyShopOrder' && this.dimensionShow([[0, 1100]]) ? 'checkbox__bodyshop' : ''
    return <InputCheckbox title={this.props.translateName} name={propName} onDisabledClick={onDisabledClick} disabled={disableCheckbox} extraClassName={bodyShopClassName} onChange={this.onInputChange} checked={checked === true} />
  }
  // renderDatetime (renderType, displayValue) {
  //   if (renderType !== RenderTypes.DATETIME) return null
  //   const { propName, order } = this.props
  //   let disabled = false

  //   if (propName === 'BodyShopProductionTime' && order.IsReferredOut) {
  //     disabled = true
  //   }

  //   return <OrderDate onUpdateOrder={this.context.onUpdateOrder} saveWorkcard={this.context.saveWorkcard} name={this.props.propName} translateKey={this.props.translateName} formatter={this.props.formatter} disabled={this.context.disabledForWP || !hasSubscriptionPermission(this.props.auth, 0, 2) || disabled} />
  // }
  renderSelectList (renderType, displayValue) {
    if (renderType !== RenderTypes.SELECTLIST) return null
    if (displayValue === null) displayValue = ''
    if (typeof displayValue === 'object') displayValue = displayValue[this.props.listItemValName[0]]

    let disabled = false
    if (this.context.disabledForWP || ['PickupAltLocationId', 'DeliveryAltLocationId'].includes(this.props.propName) && !hasSubscriptionPermission(this.props.auth, 0, 2)) disabled = true
    if (this.props.auth.user.DepartmentType === 1 && ['PickupAltLocationId', 'DeliveryAltLocationId'].includes(this.props.propName) && this.props.order.IsReferredOut) disabled = true

    return <InputSelectList title={this.props.translateName} translate={this.props.translate} name={this.props.propName} value={displayValue} onChange={this.onInputChange} listItems={this.props.listItems} listItemValName={this.props.listItemValName} disabled={disabled} />
  }
  renderRadioList (renderType, displayValue) {
    const { propName } = this.props
    if (renderType !== RenderTypes.RADIOLIST) return null
    if (displayValue === null) displayValue = ''
    if (typeof displayValue === 'object') displayValue = displayValue[this.props.listItemValName[0]]

    let disabled = (propName === 'Transport' || propName === 'LoosePartsType') && !hasSubscriptionPermission(this.props.auth, 0, 2) || this.context.disabledForWP
    var listItems = this.props.listItems
    // isCustomer
    if (hasAccess([4], this.props.auth.user.UserType) && (this.props.auth.user.DepartmentType === 0 && !this.props.order.IsDraft || this.props.auth.user.DepartmentType === 1 && !this.props.order.BodyShopIsDraft)) disabled = true
    if (disabled === false && propName === 'LoosePartsType' &&
      ((!hasSubscriptionPermission(this.props.auth, 10) && !hasPartnerSubscriptionPermission(this.props.auth, 10)) ||
        (this.props.auth.user.DepartmentType === 1 && this.props.order.IsReferredOut)
      )) disabled = true

    if (propName === 'Transport' && listItems !== undefined && (!hasSubscriptionPermission(this.props.auth, 10) && !hasPartnerSubscriptionPermission(this.props.auth, 10))) {
      listItems.map((item) => {
        if (item.Name === '351') listItems.splice(listItems.indexOf(item), 1)
      })
    }
    // if ((propName === 'Transport' || propName === 'LoosePartsType') && this.props.order.IsAssessmentOk) {
    //   if (propName !== 'LoosePartsType' && this.props.order.Transport === 2) disabled = true
    //   if (propName === 'Transport' && this.props.order.Transport !== 2 && index === 2) disabled = true
    // }
    return <RadioList title={this.props.translateName} translate name={this.props.propName} value={'' + displayValue} formatter={this.props.formatter} onChange={this.onInputChange} listItems={listItems} listItemValName={this.props.listItemValName} disabled={disabled} />
  }
  renderCheckboxList (renderType, displayValue) {
    if (renderType !== RenderTypes.CHECKBOXLIST) return null
    if (displayValue === null) displayValue = ''
    return <RadioList title={this.props.translateName} translate name={this.props.propName} value={'' + displayValue} formatter={this.props.formatter} onChange={this.onInputChange} listItems={this.props.listItems} listItemValName={this.props.listItemValName} disabled={['Transport'].includes(this.props.propName) && !hasSubscriptionPermission(this.props.auth, 0, 2) || this.context.disabledForWP} />
  }
  renderInputfield2 (renderType, displayValue) {
    if (renderType !== RenderTypes.INPUTFIELD2) return null
    let blur = this.onBlur
    let disabled = false
    if (['LTWIdCode', 'PickupAltLocationComment', 'DeliveryAltLocationComment'].includes(this.props.propName) && !hasSubscriptionPermission(this.props.auth, 0, 2) || this.context.disabledForWP) disabled = true

    return (
      <Text
        name={this.props.propName}
        value={this.props.order[this.props.propName] !== null ? (this.props.propName === 'ChassisNumber' ? this.props.order[this.props.propName].toUpperCase() : this.props.order[this.props.propName]) : ''}
        onChange={this.onInputChange}
        placeholder={this.props.translateName}
        onBlur={blur}
        disabled={disabled}
      />
    )
    // return (
    //   <div>
    //     <label className='labelOverwrite'>&nbsp;</label>
    //     <input type='text' name={this.props.propName} value={this.props.order[this.props.propName] !== null ? (this.props.propName === 'ChassisNumber' ? this.props.order[this.props.propName].toUpperCase() : this.props.order[this.props.propName]) : ''} onChange={this.onInputChange} placeholder={this.props.translateName} onBlur={blur} disabled={['LTWIdCode', 'PickupAltLocationComment', 'DeliveryAltLocationComment'].includes(this.props.propName) && !hasSubscriptionPermission(this.props.auth, 0, 2) || this.context.disabledForWP} />
    //   </div>
    // )
  }
  renderSelectList2 (renderType, displayValue) {
    if (renderType !== RenderTypes.SELECTLIST2) return null
    let listItemValName = this.props.listItemValName
    if (displayValue === null) displayValue = ''
    if (typeof displayValue === 'object') displayValue = displayValue[listItemValName[0]]

    let disabled = false
    let spacing = 0
    if (['PickupAltLocationId', 'DeliveryAltLocationId', 'BodyShopPickupAltLocationId', 'BodyShopDeliveryAltLocationId'].includes(this.props.propName)) {
      spacing = -1
    }

    if (this.context.disabledForWP || ['PickupAltLocationId', 'DeliveryAltLocationId'].includes(this.props.propName) && !hasSubscriptionPermission(this.props.auth, 0, 2)) disabled = true
    if (['BodyShopPickupAltLocationId', 'BodyShopDeliveryAltLocationId'].includes(this.props.propName) && this.props.order.IsReferredIn) disabled = true

    return (
      <DropDown
        name={this.props.propName}
        value={displayValue.toString()}
        onChange={this.onInputChange}
        spacing={spacing}
        disabled={disabled}
      >
        {this.props.listItems && this.props.listItems.map((val, index) => {
          let className = (this.props.propName === 'CarRentalId' && val.isFree === false) ? 'warning' : ''
          let showVal = (this.props.translate) ? translation(val[listItemValName[1]]) : val[listItemValName[1]]
          return <option value={val[listItemValName[0]].toString()} className={className} key={index}>{showVal}</option>
        })}
      </DropDown>
    )
  }
  renderTextarea (renderType, displayValue) {
    const { propName, order } = this.props
    if (renderType !== RenderTypes.TEXTAREA) return null

    let disabled = false
    if (['BodyShopPickupAltLocationComment', 'BodyShopDeliveryAltLocationComment'].includes(propName) && order.IsReferredIn) disabled = true
    if (this.props.auth.user.DepartmentType === 1 && ['PickupAltLocationComment', 'DeliveryAltLocationComment'].includes(propName) && order.IsReferredOut) disabled = true

    return (
      <Textarea
        name={propName}
        value={order[propName]}
        placeholder={order[propName]}
        onChange={this.onInputChange}
        onBlur={this.onBlur}
        disabled={disabled}
      />
    )
  }
  renderInput (translateName, propName, formatter, type, listItems, listItemValName, translate) {
    // Get rendertypes from configuration for propName
    let config = GetConfig(propName)
    if (typeof config === 'undefined') return null
    let displayValue = this.props.order[propName]
    translateName = translation(translateName)
    if (type === 'checkbox' || type === 'checkboxicon') displayValue = displayValue ? translation('47') : translation('48')
    let isCustomer = hasAccess([4], this.props.auth.user.UserType)
    let isDraft = this.props.auth.user.DepartmentType === 0 && this.props.order.IsDraft || this.props.auth.user.DepartmentType === 1 && this.props.order.BodyShopIsDraft
    let renderType = RenderTypes.NONE
    if (isCustomer) {
      renderType = isDraft ? config.draftCustomerRenderType : config.bookedCustomerRenderType
    } else {
      renderType = isDraft ? config.draftShopRenderType : config.bookedShopRenderType
    }
    if (renderType === RenderTypes.NONE) return null

    if (renderType === RenderTypes.CHECKBOX && type === 'checkboxicon') renderType = RenderTypes.CHECKBOXICON
    if (renderType === RenderTypes.INPUT && type === 'inputicon') renderType = RenderTypes.INPUTICON
    if (typeof renderType === 'undefined') renderType = RenderTypes.FORMATTER
    return (
      <div className={'workcard-input--' + propName}>
        {this.renderDisplayFormatter(renderType, displayValue)}
        {this.renderInputfield(renderType, displayValue)}
        {this.renderCheckbox(renderType, displayValue)}
        {/* this.renderDatetime(renderType, displayValue) */}
        {this.renderSelectList(renderType, displayValue)}
        {this.renderRadioList(renderType, displayValue)}
        {this.renderCheckboxList(renderType, displayValue)}
        {this.renderInputfield2(renderType, displayValue)}
        {this.renderSelectList2(renderType, displayValue)}
        {this.renderTextarea(renderType, displayValue)}
      </div>
    )
  }

  render () {
    if (typeof this.props.order.Id === 'undefined') return null
    return this.renderInput(this.props.translateName, this.props.propName, this.props.formatter, this.props.type, this.props.listItems, this.props.listItemValName, this.props.translate)
  }
}

InputRender.defaultProps = {
  translate: false
}

InputRender.propTypes = {
  order: PropTypes.object.isRequired,
  translateName: PropTypes.string.isRequired,
  propName: PropTypes.string.isRequired,
  formatter: PropTypes.func,
  type: PropTypes.string,
  listItems: PropTypes.array,
  listItemValName: PropTypes.array,
  translate: PropTypes.bool,
  auth: PropTypes.object.isRequired
}
InputRender.contextTypes = {
  // t: React.PropTypes.func.isRequired,
  dimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }),
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onUpdateOrder: PropTypes.func.isRequired,
  saveWorkcard: PropTypes.func.isRequired,
  disabledForWP: PropTypes.bool
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
})(InputRender)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/InputRender/index.js